export enum RequestSource {
  LOGIN = "login",
  SIGNUP = "signup",
  CHANGE_PASSWORD = "change_password",
  PASSWORD_RECOVERY = "password_recovery",
  FETCH_DATA = "fetch_data",
  UPDATE_PROFILE = "update_profile",
  // Add more sources as needed
}
